import { useGetApiEmployeeOvertimeCalculations, } from '../../generated/sitComponents';
import { CACHE_TIMES } from '../query';
export function useGetEmployeeOvertimeCalculations(variables, options) {
    return useGetApiEmployeeOvertimeCalculations(variables, {
        staleTime: CACHE_TIMES.ONE_MINUTE,
        gcTime: CACHE_TIMES.FIVE_MINUTES,
        ...options,
    });
}
//# sourceMappingURL=use-get-employee-overtime-calculations.js.map